import type { PublicRoute } from "../../../routes/registry";
import HomePage from "./HomePage";

/** BR-WEB-004 — legacy home title and meta description, verbatim (baseline § 3). */
const route: PublicRoute = {
  path: "/",
  element: <HomePage />,
  title: "Greatway Patios | Toowoomba's leading Patio, Decking, Carport and Outdoor Living business",
  description:
    "Greatway Patios Toowoomba offers high quality outdoor living solutions including Patios, Outdoor Living Rooms and more.",
};

export default route;
